<template>
  <div>
    <ValidationObserver ref="form">
      <div class="grid">
        <div class="vx-row" @click="changeSelectorOpened(true)">
          <div class="vx-col w-full">
            <vs-tabs alignment="right" v-model="dishCurrentLanguage">
              <vs-tab
                v-if="languages[lang]"
                @click="clickTabChangeLang(lang)"
                :label="languages[lang]"
                v-for="(lang, index) in dishForm.allowedLanguages"
                :key="index"
              >
              </vs-tab>
            </vs-tabs>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Nombre"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  label="Nombre"
                  v-model="dishForm.name"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Categoría"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-select
                  autocomplete
                  label="Categoría"
                  v-model="dishForm.category"
                  class="selectCategories w-full"
                  @click="changeSelectorOpened()"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in listCategories"
                  />
                </vs-select>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <ValidationProvider
              name="Descripción"
              rules="required"
              v-slot="{ errors }"
            >
              <vx-input-group class="mb-2 mt-3">
                <vs-textarea
                  label="Descripción"
                  v-model="dishForm.description"
                  rows="6"
                  counter="250"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </vx-input-group>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Tamaño"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  label-placeholder="Tamaño"
                  v-model="dishForm.size"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <ValidationProvider
                name="Precio"
                rules="required|min_value:0"
                v-slot="{ errors }"
              >
                <vs-input
                  label-placeholder="Precio"
                  v-model="dishForm.price"
                  type="number"
                  step="0.01"
                  :min="0"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col">
            <vs-checkbox v-model="keepPrice">{{
              $t("SinVariacionPrecio")
            }}</vs-checkbox>
          </div>

          <div v-if="!keepPrice" class="vx-col w-full hour-container">
            <div class="vx-col mt-10 w-full">{{ $t("EligeHorario") }}</div>
            <div
              class="vx-row flex items-center hour-row-heigth flex"
              style="align-items: flex-start !important"
              v-for="(hour, indexHour) in aux_price_per_hour"
              :key="indexHour"
            >
              <div class="vx-col sm:w-1/12 flex" style="margin-top: 2.25rem">
                <p style="min-width: 65px">{{ daysTranslate[hour.day] }}</p>
              </div>
              <div class="vx-col sm:w-4/12 hour-range-input">
                <vx-input-group>
                  <TimeRangeInput
                    :value="{
                      fromTime: aux_price_per_hour[indexHour].since,
                      toTime: aux_price_per_hour[indexHour].until,
                    }"
                    @input="setPricePerHours($event, indexHour)"
                  ></TimeRangeInput>
                </vx-input-group>
              </div>
              <div class="vx-col sm:w-2/12">
                <vx-input-group>
                  <ValidationProvider
                    name="Precio"
                    :rules="
                      isPercentage[hour.day]
                        ? 'required|max_value:100'
                        : 'required'
                    "
                    v-slot="{ errors }"
                  >
                    <vs-input
                      :label="isPercentage[hour.day] ? '%Precio' : 'Precio'"
                      min="0"
                      v-model="hour.price"
                      type="number"
                      class="w-full"
                    />
                    <p class="text-danger" style="width: 102.08px">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </vx-input-group>
              </div>
              <div class="vx-col md:w-2/12" style="margin-top: 2.25rem">
                <vs-switch
                  v-model="isPercentage[hour.day]"
                  :disabled="hour.since != ''"
                >
                  <template #on>
                    {{ $t("percentage") }}
                  </template>
                  <template #off>
                    {{ $t("Price") }}
                  </template>
                </vs-switch>
              </div>
              <div
                class="vx-col sm:w-3/12 flex h-10"
                style="margin-top: 1.75rem"
              >
                <vs-button size="small" @click="addVariablePrice(indexHour)">
                  {{ $t("ConfirmPrice") }}
                </vs-button>
              </div>
            </div>

            <div style="max-width: 750px; margin-top: 20px; text-align: left">
              <vs-table :data="dishForm.hours">
                <template slot="header">
                  <h3>
                    {{ $t("TimePrice") }}
                  </h3>
                </template>

                <template slot="thead">
                  <vs-th sort-key="day">
                    {{ $t("Day") }}
                  </vs-th>
                  <vs-th sort-key="hours">
                    {{ $t("Hours") }}
                  </vs-th>
                  <vs-th sort-key="price">
                    {{ $t("Price") }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].day">
                      {{ daysTranslate[data[indextr].day] }}
                    </vs-td>

                    <vs-td :data="data[indextr].hours">
                      <div
                        class="flex items-center"
                        v-for="(hour_with_price, indexHourPrice) in formatHour(
                          tr.hours
                        )"
                        :key="indexHourPrice"
                      >
                        <p>{{ hour_with_price }}</p>
                      </div>
                    </vs-td>

                    <vs-td :data="data[indextr].price">
                      {{ data[indextr].price }}
                      <span v-if="isPercentage[data[indextr].day]">%</span>
                      <span v-if="!isPercentage[data[indextr].day]">€</span>
                    </vs-td>
                    <vs-td>
                      <vs-button
                        color="danger"
                        type="border"
                        size="small"
                        class="ml-3 w-24"
                        @click="deleteVariablePrice(indextr)"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        />
                      </vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <p>{{ $t("Ingredientes") }}</p>
              <ValidationProvider
                name="Ingredientes"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-chips
                  color="rgb(145, 32, 159)"
                  placeholder="Ingredientes"
                  v-model="dishForm.ingredients"
                >
                  <vs-chip
                    :key="ingredient"
                    @click="remove(ingredient)"
                    v-for="ingredient in dishForm.ingredients"
                    closable
                  >
                    {{ ingredient }}
                  </vs-chip>
                </vs-chips>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <vs-select
                autocomplete
                label="Sugerencia"
                v-model="dishForm.suggestions"
                class="selectSuggestion w-full"
                @click="changeSelectorOpened()"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item, index) in listSuggestions"
                />
              </vs-select>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <label>{{ $t("Alergenos") }}</label>
              <ul class="vx-row">
                <li
                  :key="index"
                  v-for="(item, index) in listAllergens"
                  class="vx-col w-1/2 mt-2"
                >
                  <vs-checkbox v-model="dishForm.allergens[item.id]">{{
                    item.name
                  }}</vs-checkbox>
                </li>
              </ul>
            </vx-input-group>
          </div>

          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <label>{{ $t("Imagenes") }}</label>
              <ImageDropzone ref="images" :files="files"></ImageDropzone>
            </vx-input-group>
          </div>
          <div class="vx-col w-full text-right">
            <vs-button
              depressed
              color="success"
              type="border"
              class="mr-2"
              @click.prevent="handleSubmit"
            >
              {{ $t("product.ActualizarProducto") }}
            </vs-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ImageDropzone from "../ImageDropzone";
import TimeRangeInput from "../time-range-input/TimeRangeInput.vue";

export default {
  props: {
    dish: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dishForm: {},
      dishFormOriginal: {},
      files: {},
      canChangeLanguage: false,
      dishCurrentLanguage: 0,
      keepPrice: true,
      daysTranslate: {
        Monday: "Lunes",
        Tuesday: "Martes",
        Wednesday: "Miércoles",
        Thursday: "Jueves",
        Friday: "Viernes",
        Saturday: "Sábado",
        Sunday: "Domingo",
      },
      isPercentage: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
      },
      aux_price_per_hour: [
        {
          day: "Monday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Tuesday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Wednesday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Thursday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Friday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Saturday",
          since: "",
          until: "",
          price: 0,
        },
        {
          day: "Sunday",
          since: "",
          until: "",
          price: 0,
        },
      ],
    };
  },
  components: {
    ImageDropzone,
    TimeRangeInput,
  },
  computed: {
    ...mapGetters({
      languages: "getLanguages",
      language: "getCurrentLanguage",
      listSuggestions: "getSuggestionsDishesList",
      listCategories: "getCategoriesDishesList",
      listAllergens: "getAllergens",
      currentRestaurant: "getCurrentRestaurant",
    }),
  },
  created() {
    this.getAllCategoriesDishes({ language: this.language });
    this.getAllAllergens({ language: this.language });
    this.dishForm = this.createDishForm(this.dish);
    this.dishForm.hours.forEach((hour) => {
      switch (hour.day) {
        case "Monday":
          this.aux_price_per_hour[0].since = hour.hours[0];
          break;
        case "Tuesday":
          this.aux_price_per_hour[1].since = hour.hours[0];
          break;
        case "Wednesday":
          this.aux_price_per_hour[2].since = hour.hours[0];
          break;
        case "Thursday":
          this.aux_price_per_hour[3].since = hour.hours[0];
          break;
        case "Friday":
          this.aux_price_per_hour[4].since = hour.hours[0];
          break;
        case "Saturday":
          this.aux_price_per_hour[5].since = hour.hours[0];
          break;
        case "Sunday":
          this.aux_price_per_hour[6].since = hour.hours[0];
          break;
        default:
          break;
      }
    });
    this.dishFormOriginal = JSON.stringify(this.dishForm);
    this.keepPrice = this.dishForm.hours.length <= 0;
    const files = new Array();
    this.dishForm.suggestions = this.dishForm.suggestions
      ? this.dishForm.suggestions
      : "";
    this.dishForm.images.forEach(function (element) {
      const m = element.path.match(/.*\/(.+?)\./);
      let name = element.path;
      if (m && m.length > 1) {
        name = m[1];
      }
      const image = {
        name,
        url: element.path,
        urlDelete: `/webadmin/dishes/delete_image/${element.id}`,
      };
      files.push(image);
    });
    this.files = files;
  },
  methods: {
    ...mapActions({
      editDish: "editDish",
      editDishChangeLanguage: "editDishChangeLanguage",
      getAllCategoriesDishes: "getAllCategoriesDishes",
      getAllAllergens: "getAllAllergens",
      getDish: "getDish",
    }),
    ...mapMutations({
      setDish: "setItemDish",
      loading: "loading",
      setpopupEditDish: "setpopupEditDish",
    }),
    setPricePerHours(event, index) {
      this.aux_price_per_hour[index].since = event.fromTime;
      this.aux_price_per_hour[index].until = event.toTime;
    },
    formatHour(hourToParse) {
      return hourToParse[0]
        .replace("[", "")
        .replace("]", "")
        .replace("/", "-")
        .split(",");
    },
    deleteVariablePrice(indexHour) {
      // console.log("index hour", this.dishForm.hours[indexHour].day);
      this.aux_price_per_hour.forEach((hour, index) => {
        if (hour.day == this.dishForm.hours[indexHour].day) {
          hour.since = "";
        }
      });
      this.dishForm.hours.splice(indexHour, 1);
    },
    addVariablePrice(index) {
      this.aux_price_per_hour[index].since = this.aux_price_per_hour[index]
        .since
        ? this.aux_price_per_hour[index].since
        : "00:00";
      this.aux_price_per_hour[index].until = this.aux_price_per_hour[index]
        .until
        ? this.aux_price_per_hour[index].until
        : "23:59";

      let varPrice = {
        day: this.aux_price_per_hour[index].day,
        price: this.aux_price_per_hour[index].price,
        hours: [
          `${this.aux_price_per_hour[index].since}/${this.aux_price_per_hour[index].until}`,
        ],
        percentage: false,
      };

      switch (varPrice.day) {
        case "Monday":
          varPrice.percentage = this.isPercentage.Monday;
          break;
        case "Tuesday":
          varPrice.percentage = this.isPercentage.Tuesday;
          break;
        case "Wednesday":
          varPrice.percentage = this.isPercentage.Wednesday;
          break;
        case "Thursday":
          varPrice.percentage = this.isPercentage.Thursday;
          break;
        case "Friday":
          varPrice.percentage = this.isPercentage.Friday;
          break;
        case "Saturday":
          varPrice.percentage = this.isPercentage.Saturday;
          break;
        case "Sunday":
          varPrice.percentage = this.isPercentage.Sunday;
          break;
        default:
          break;
      }

      //Si el precio es porcentaje
      if (
        (varPrice.percentage && !/^[1-9][0-9]?$|^100$/.test(varPrice.price)) ||
        !/^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/.test(
          varPrice.price
        )
      ) {
        this.$store.commit("notifications", {
          title: "menu.InvalidPrice",
          color: "warning",
        });
        this.$store.commit("showNotifications", true);
        return;
      }

      for (let i = 0; i < this.dishForm.hours.length; i++) {
        //Si ya hay un horario en ese día con ese precio
        if (
          this.dishForm.hours[i].day === varPrice.day &&
          this.dishForm.hours[i].price === varPrice.price
        ) {
          //Si es el mismo horario, avisar de que está repetido
          if (this.dishForm.hours[i].hours.includes(varPrice.hours[0])) {
            this.$store.commit("notifications", {
              title: "menu.AlreadyExists",
              color: "warning",
            });
            this.$store.commit("showNotifications", true);
            return;
          }
          //Si no es el mismo horario, añadir a la lista de horarios de ese precio en ese día
          this.$store.commit("notifications", {
            title: "menu.UpdateVariableMenuPrice",
          });
          this.$store.commit("showNotifications", true);
          this.dishForm.hours[i].hours.push(varPrice.hours[0]);
          return;
          // eslint-disable-next-line brace-style
        }

        //Si el horario es el mismo en el mismmo día pero con precios distintos, no puede tener dos precios distintos a la vez
        else if (
          this.dishForm.hours[i].day === varPrice.day &&
          this.dishForm.hours[i].hours.includes(varPrice.hours[0])
        ) {
          this.$store.commit("notifications", {
            title: "menu.DifferentPrice",
            color: "warning",
          });
          this.$store.commit("showNotifications", true);
          return;
        }
      }

      this.dishForm.hours.push(varPrice);
      this.$store.commit("notifications", { title: "menu.HorarioAnyadido" });
      this.$store.commit("showNotifications", true);
    },
    changeSelectorOpened(wait = false) {
      global.jQuery = require("jquery");
      var $ = global.jQuery;

      if (wait) {
        setTimeout(() => {
          const vsSelectedCategories =
            document.getElementsByClassName("vs-select--options")[0];
          const vsSelectedSuggestions =
            document.getElementsByClassName("vs-select--options")[1];
          if (
            !(
              vsSelectedCategories.style.display === "none" &&
              vsSelectedSuggestions.style.display === "none"
            )
          ) {
            vsSelectedCategories.addEventListener("click", () => {
              this.changeSelectorOpened(true);
            });

            vsSelectedSuggestions.addEventListener("click", () => {
              this.changeSelectorOpened(true);
            });
            $("body").addClass("stop_scrolling");
            $(".vs-popup--content").addClass("stop_scrolling");
          } else {
            $("body").removeClass("stop_scrolling");
            $(".vs-popup--content").removeClass("stop_scrolling");
          }
        }, 100);
      } else {
        const vsSelectedCategories =
          document.getElementsByClassName("vs-select--options")[0];
        const vsSelectedSuggestions =
          document.getElementsByClassName("vs-select--options")[1];
        if (
          !(
            vsSelectedCategories.style.display === "none" &&
            vsSelectedSuggestions.style.display === "none"
          )
        ) {
          vsSelectedCategories.addEventListener("click", () => {
            this.changeSelectorOpened(true);
          });

          vsSelectedSuggestions.addEventListener("click", () => {
            this.changeSelectorOpened(true);
          });
          $("body").addClass("stop_scrolling");
          $(".vs-popup--content").addClass("stop_scrolling");
        } else {
          $("body").removeClass("stop_scrolling");
          $(".vs-popup--content").removeClass("stop_scrolling");
        }
      }
    },
    createDishForm(dish) {
      this.canChangeLanguage = false;
      const arrayAllergens = new Array();

      dish.allergens.forEach(function (element) {
        arrayAllergens[element.id] = 1;
      });
      let ingredients = new Array();
      if (dish.ingredients) {
        ingredients = dish.ingredients;
      }
      const arrayAllowedLanguages = eval(dish.allowed_languages);
      for (let i = 0; arrayAllowedLanguages.length > i; i++) {
        if (arrayAllowedLanguages[i] === dish.current_language) {
          this.dishCurrentLanguage = i;
          this.canChangeLanguage = true;
        }
      }
      return {
        id: dish.id,
        name: dish.name,
        description: dish.description,
        category: dish.category.id,
        ingredients,
        allergens: arrayAllergens,
        suggestions: dish.suggestions,
        images: dish.images,
        size: dish.size,
        price: dish.price,
        allowedLanguages: arrayAllowedLanguages,
        currentLanguage: dish.current_language,
        hours: dish.hours ? dish.hours : [],
      };
    },
    remove(item) {
      this.dishForm.ingredients.splice(
        this.dishForm.ingredients.indexOf(item),
        1
      );
    },
    checkImages() {
      global.jQuery = require("jquery");
      var $ = global.jQuery;
      const vsSelectedCategories =
        document.getElementsByClassName("dz-preview")[0];

      if (vsSelectedCategories !== undefined && vsSelectedCategories)
        return true;
      else return false;
    },
    handleSubmit() {
      this.$refs.form.validate().then((success) => {
        const formData = this.createFormData();

        // if (!this.checkImages()||this.dishForm.description.length>250) {
        //   success = false;
        // }

        if (
          !this.dishForm.description ||
          this.dishForm.description.length > 250 ||
          this.dishForm.description.length === 0
        ) {
          success = false;
        }
        if (!success) {
          setTimeout(() => {
            let textAux = "";
            const errors = this.$refs.form.errors;
            if (errors && errors !== undefined) {
              Object.keys(errors).forEach((key) => {
                const error = errors[key];
                if (error.length) {
                  error.forEach(function (text) {
                    textAux += `<p>${text}</p>`;
                  });
                }
              });
            }

            // if (!this.checkImages()) {
            //   textAux += "<p>El campo Imágenes es obligatorio</p>";
            // }

            // if (!this.dishForm.description||this.dishForm.description.length>250||this.dishForm.description.length===0) {
            //   textAux += "<p>El campo Descripción es obligatorio y debe ser menor a 250 caracteres</p>";
            // }
            this.$store.commit("notifications", {
              title: "Existen errores en el formulario.",
              color: "danger",
              text: textAux,
            });
            this.$store.commit("showNotifications", true);
          }, 100);
          return;
        }

        this.submitted = true;

        this.editDish({
          id: this.dishForm.id,
          dish: formData,
          language: this.dishForm.currentLanguage,
        });

        function isFile(input) {
          if ("File" in window && input instanceof File) return true;
          else return false;
        }
        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    createFormData() {
      // const data = new FormData();
      const data = this.$refs.images.getFormData();

      const arrayAllergens = new Array();
      const arrayIngredients = new Array();
      const arrayTags = new Array();

      if (!this.keepPrice) {
        for (let i = 0; i < this.dishForm.hours.length; i++) {
          const day = this.dishForm.hours[i].day;
          if (this.isPercentage[day]) {
            this.dishForm.hours[i].percentage = this.dishForm.hours[i].price;
            this.dishForm.hours[i].price = null;
          } else {
            this.dishForm.hours[i].percentage = null;
          }

          if (!Array.isArray(this.dishForm.hours[i].hours)) {
            this.dishForm.hours[i].hours = [this.dishForm.hours[i].hours];
          }

          data.append(`hours[${i}]`, JSON.stringify(this.dishForm.hours[i]));
        }
      }

      this.dishForm.allergens.forEach(function (element, index) {
        if (element === 1 || element === true) {
          arrayAllergens.push(index);
        }
      });
      if (this.dishForm.ingredients.length > 0) {
        this.dishForm.ingredients.forEach(function (element) {
          arrayIngredients.push(element);
        });
        for (let i = 0; i < arrayIngredients.length; i++) {
          data.append(`ingredients[${i}]`, arrayIngredients[i]);
        }
      } else {
        data.append("ingredients", "");
      }

      data.append("name", this.dishForm.name);
      data.append(
        "description",
        this.dishForm.description ? this.dishForm.description : ""
      );
      data.append("size", this.dishForm.size);
      data.append("suggestions", this.dishForm.suggestions);
      data.append("price", this.dishForm.price);
      data.append("category_id", this.dishForm.category);

      for (let i = 0; i < arrayAllergens.length; i++) {
        data.append(`allergens[${i}]`, arrayAllergens[i]);
      }

      data.append("restaurant_id", this.currentRestaurant);
      for (let i = 0; i < arrayTags.length; i++) {
        data.append(`tags[${i}]`, arrayTags[i]);
      }

      return data;
    },
    clickTabChangeLang(value) {
      const arrayAllowedLanguages = this.dishForm.allowedLanguages;
      if (this.dishForm.currentLanguage !== value) {
        const currentLanguage = this.dishForm.current_language;
        let indexCurrentLanguage = 0;
        for (let i = 0; arrayAllowedLanguages.length > i; i++) {
          if (arrayAllowedLanguages[i] === currentLanguage) {
            indexCurrentLanguage = i;
          }
        }
        this.changeLanguage(value, indexCurrentLanguage);
      }
    },
    changeLanguage(lang, currentIndex) {
      const aux = this;
      aux.canChangeLanguage = false;
      if (
        JSON.stringify(aux.dishForm) !== JSON.stringify(aux.dishFormOriginal)
      ) {
        this.$vs.dialog({
          type: "confirm",
          color: "success",
          title: this.$t("changeLanguage"),
          text: this.$t("textChangeLanguage"),
          acceptText: aux.$t("SalirGuardar"),
          cancelText: aux.$t("Cancelar"),
          accept(e) {
            aux.$refs.form.validate().then((success) => {
              if (
                !aux.dishForm.description ||
                aux.dishForm.description.length > 250 ||
                aux.dishForm.description.length === 0
              ) {
                success = false;
              }
              if (!success) {
                aux.handleSubmit();
                aux.dishCurrentLanguage = currentIndex;
                aux.canChangeLanguage = true;
              } else {
                aux.loading(true);
                const formData = aux.createFormData();

                aux
                  .editDishChangeLanguage({
                    id: aux.dishForm.id,
                    dish: formData,
                    language: aux.dishForm.currentLanguage,
                    newLanguage: lang,
                  })
                  .then(() => {
                    aux
                      .getDish({
                        id: aux.dishForm.id,
                        language: lang,
                        isEditDish: true,
                      })
                      .then(() => {
                        this.$store.commit("setpopupEditDish", true);
                        aux.loading(false);
                      });
                  });
              }
            });
          },
          cancel() {
            aux.dishCurrentLanguage = currentIndex;
            aux.canChangeLanguage = true;
          },
        });
      } else {
        aux.loading(true);
        aux.getDish({ id: aux.dishForm.id, language: lang });
      }
    },
  },
  destroyed() {
    this.$store.commit("setpopupEditDish", false);
  },
};
</script>
<style>
.hour-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hour-row-heigth {
  align-items: center !important;
}

.hour-range-input {
  display: flex !important;
  align-items: center;
  margin-bottom: 1.25rem;
  justify-content: center;
}

.stop_scrolling {
  overflow: hidden;
}
</style>
